export enum QuestionOperator
{
    HigherThan = 1,
    LessThan = 2,
    Equals = 3,
    Between = 4,
    Empty = 5,
    Completed = 6,
    DateFromWithValue=7
}